export class DiagnosisItemStatus {
    public static FAILED = 'FAILED';
    public static SUCCESS = 'SUCCESS';
    public static TIMEOUT = 'TIMEOUT';
    public static RUNNING = 'RUNNING';
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/model/diagnosis-item-status.ts